module.exports = "./assets/assets/抽取流程.777a7e19.docx";